import axios from 'axios';
import { API_BASE_URL } from '../../config/api';


const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    }
});

// Add token to requests if it exists
const token = localStorage.getItem('token');
if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Add request interceptor to always add the latest token
axiosInstance.interceptors.request.use(
    async (config) => {
        // Get the latest token from localStorage
        const currentToken = localStorage.getItem('token');
        if (currentToken) {
            config.headers['Authorization'] = `Bearer ${currentToken}`;
        }
        
        // Get CSRF token from cookien
        const csrfToken = getCsrfToken();
        
        // For non-GET requests, include CSRF token
        if (config.method?.toLowerCase() !== 'get') {
            if (csrfToken) {
                config.headers['X-XSRF-TOKEN'] = csrfToken;
            }
        }
        
        // For FormData, let browser set Content-Type
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.log('Unauthorized access - redirecting to login');
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Helper function to get CSRF token from cookies
function getCsrfToken(): string | null {
    const cookies = document.cookie.split('; ');
    const csrfCookie = cookies.find(row => row.startsWith('XSRF-TOKEN='));
    return csrfCookie ? decodeURIComponent(csrfCookie.split('=')[1]) : null;
}

// Function to fetch CSRF token
// @ts-ignore - Function kept for future use
async function fetchCsrfToken(): Promise<void> {
    try {
        await axios.get(`${API_BASE_URL}/sanctum/csrf-cookie`, {
            withCredentials: true
        });
        console.log('CSRF token fetched successfully');
    } catch (error) {
        console.error('Failed to fetch CSRF token:', error);
    }
}
export default axiosInstance;